import { mergeObjectTypes } from '../cacheHelpers';

const Stage = {
  merge: mergeObjectTypes
};

export default Stage;
